<div class="top x-container container">
    <slot name="topMenu"/>
</div>
<slot name="stories"/>


